<template>
  <div :class="{'screen':isAllScreen}" class="map-big-screen">
    <div class="map-big-screen-over">
      <div class="map-shadow"></div>
      <div class="map-shadow down"></div>
      <!-- <span class="goBack" @click="goBack" v-if="zone !== 'world'">返回 ></span> -->
      <div class="map-container" ref="mapContainer"></div>
    </div>
  </div>
</template>

<script>
import echarts from '../../../../public/js/echart/echarts.min'
import echartsJson from '../../../../public/js/echart/customed.json'
import { worldJson } from './initMap.js'
export default {
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  computed: {

    isAllScreen () {
      return this.$store.state.isAllScreen
    },
  },
  data () {
    return {
      locationIcon: require('@/assets/images/bigScreen/location.png'),
      myChart: null,
      zone: 'world'
    }
  },
  mounted () {
    worldJson(this.zone, echarts, () => {
      this.$emit('inited', true)
      echarts.registerTheme('customed', echartsJson)
      this.$nextTick(() => {
        this.initMapConfig()
        // 监听全屏事件
        window.addEventListener('resize', () => {
          if (this.myChart) {
            setTimeout(() => {
              this.myChart.resize()
            }, 60)
          }
        })
      })

    })

  },
  methods: {
    initMapConfig (type = 'world') {
      let that = this
      let myChart = echarts.init(this.$refs.mapContainer, 'customed')
      myChart.setOption(
        // 初始化echarts配置
        {
          geo: [ {
              map: 'world',
              zoom: 1,
              label: {
                normal: {
                  show: false,
                },
                emphasis: {
                  show: false,
                },
              },
              itemStyle: {
                // 设置国家填充色和边界色
                normal: {
                  areaColor: '#142041',
                  borderWidth: 1,
                  borderColor: '#010A20'
                },
                emphasis: {
                  // label: {
                  //   show: true,
                  //   color: '#0560fd',
                  // },
                  areaColor: '#142041',
                  // borderWidth: 1,
                  // shadowColor: 'rgba(5, 96, 253, 1)',
                  // shadowBlur: 2,
                  borderColor: '#010A20'
                }
              },
              select: {
                label: {
                  show: false,
                },
                itemStyle: {
                  // 设置国家填充色和边界色
                  areaColor: '#142041',
                  borderWidth: 1,
                  borderColor: '#142041',
                  normal: {
                    areaColor: '#142041',
                    borderWidth: 1,
                    borderColor: '#010A20'
                  },
                },
              },
              layoutCenter: ['30%', '20%'], // 地图中心位置，layoutCenter和layoutSize确保地图比例不变
              roam: 'move',
              data: []
            }],
          tooltip: {
            alwaysShowContent: true, // 不自动隐藏
            enterable: false, // 鼠标可移入
            confine: true,
            appendToBody: true,
            triggerOn: 'move',
            className: 'map-tooltip-wrapper',
            padding: 0,
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            extraCssText: 'z-index: 2002',
            position: function (point, params, dom, rect, size) {
                return [point[0], point[1]];
            },
            formatter: (params, ticket, callback) => {
              let content = ''
              if (this.config.formatter.length) {
                for (let i = 0; i < this.config.formatter.length; i++) {
                  let num = (params.data && params.data.value[2] && params.data.value[2].data && params.data.value[2].data[this.config.formatter[i].key]) || 0
                  content += ` <div class="tooltips-item">
                  <span class="item-name">${this.config.formatter[i].name}</span>
                  <span class="item-value">${this.config.formatter[i].unit || ''}${this.config.formatter[i].unit ? Number(num).toFixed(2) : num
                    }</span>
                </div>`
                }
              }
              // <img src="${this.locationIcon}"/>
              return `
              <div class="tooltips-container map-tooltip-content">
                <div class="tooltips-head">
                  <span><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAzNJREFUWEe1l01sTGEUht+3VbWQ7qpq7pBKxcq/hE3RpHq/aZUFqZ1WhJIoIixIBIloohaERBHxsxHKQmlnLhI/tRAhElZCNNxv2rS1kVi0aTpHZrTamd6/abm7O9857/ucc7+/IbJ4xJpXgsRwHSALAS4HUQKiD4J+kJ+RkDYkhjtZ3fMtqCyDBEqseDmYWw9BHYCCADlnMJRoZk33D79YXwCxjCYIDgKY7ieWMf4JwpOM2Le98jwBxAq3QaQmS+P0cGIfTX3BTcMVQKKhBpAtUzIfTRacZESfcNJyBBArtAHCh//EfAyinBH9PFPTBSBQ67sB6fkjyGIAc3yAn1Ppcl+AANV3g9JAM/5ovNhI3mVPEJFaRuKt4/MmdEBi4ZuAbHOp5guVXuBVqcSMzwBKHWPIVpp2rQ+AYQMwnAVyVtL8/s4TwJq7ApJ46zrrlU4rOu1F2kNLkcv3zubooKmrg0xMsYx2CKocY6flzWZFV+/oWDpA1FgH4pmLyVUqvSsQQMy4AmCnY6xgCSP6Q/YAZBNN+2ggACt8GiJHXGJXUek32QNAblDFtwcCiIWuA6x3jB1KFI4/I9I/QUdpAXIGfjqb8CmVvT4YQPgJIBUOsT1UOm2/mLgMo4YFotLF6CKVbvRZhsl9f69zjLyiipd5L0PLOA6B476dSszhJlbabU4G8ji8EQl54AHYSKUv+uwD84qB4eQ6dt9aBddAeQEZ7kyJMbcMwrUgdniYf0H+4DKW9//yBEgOil8XgkyEzBjhMUbsU5k/Ox9GzwpnYiD/CYjVk/GakCN4jRmD6zOrTzXPzUCs8BqIPAaQP0WIQZCVNO2XTjreN6KYsR/AuSkCHKDS5900/O+E3qejDxtvUdnJi6zr4wswMik/QLAoq04QH2nqxX45AQG8j1hHE/of3Z6TcMIq6ggfQo40+1WUGk/wMKvss0FiA3VgVEhixj0Am32E71PpLUHMs+rAOIivAEpcDLqo9Pyg5pMDsIpmQfL+3mjSzDhURLO3778CpFZFLFQL8E66kWylit/NxnxSHRj7FOFLgOz+884WKntPtuZTAkh1Imok/weAEd0wGfNkzm91DyEwb4sA9wAAAABJRU5ErkJggg==" 
                  style="width: 16px;margin-right: 6px;" />${params.name}</span></div>
                <div class="tooltips-content">
                ${content}
                </div>
              </div>
            `
            }
          },
          series: [
           
          ]
        },
        true
      )
      myChart.on('mousemove', function (params) {
        // let result = worldJson(params.name, echarts)
        // if (result === 0) {
        //   return
        // }
        // that.myChart = null
        // that.zone = params.name
        // that.initMapConfig(params.name)
        // that.myChart.resize()
        that.$emit('changeZone', params)
      })
      myChart.on('highlight', function (params) {

        // let result = worldJson(params.name, echarts)
        // if (result === 0) {
        //   return
        // }
        // that.myChart = null
        // that.zone = params.name
        // that.initMapConfig(params.name)
        // that.myChart.resize()
        that.$emit('changeZone', params)
      })
      myChart.on('click', function (params) {

        // let result = worldJson(params.name, echarts)
        // if (result === 0) {
        //   return
        // }
        // that.myChart = null
        // that.zone = params.name
        // that.initMapConfig(params.name)
        // that.myChart.resize()
        that.$emit('changeZone', params)
      })
      this.myChart = myChart
      this.$emit('changeZone', { name: 'world' })

    },
    goBack () {
      this.zone = 'world'
      worldJson('world', echarts)
      this.initMapConfig('world')
      this.$emit('changeZone', { name: 'world' })
    }
  }
}
</script>
<style lang="scss">
@function trl($px: 14px) {
  @return ($px * 100vw)/ 1440px;
}
.map-tooltip-wrapper {
  width: 0;
  height: 0;
}
.map-tooltip-content.tooltips-container {
  pointer-events: none;
  padding: trl(16px);
  width: trl(177px);
  border: 1px solid rgba(255, 255, 255, 0.16);
  transform: translate(trl(-10px), 0);
  // border-image: linear-gradient(137deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.06)) 1 1;
  background: rgba($color: #142041, $alpha: 1);
  border-radius: trl(4px);

  position: relative;
  .tooltips-head {
    font-size: trl(14px);
    position: absolute;
    top: trl(-30px);
    left: trl(-13px);
    color: #fff;
    font-weight: 600;
    line-height: trl(16px);
    margin-bottom: trl(8px);
  }

  .tooltips-content {
    .tooltips-item {
      min-width: trl(100px);
      margin-bottom: trl(12px);
      font-size: trl(14px);
      display: flex;
      align-items: center;
      text-align: left;
      color: #fff;
      line-height: trl(16px);
      &:last-child {
        margin-bottom: 0;
      }
      .item-name {
        width: trl(56px);
        display: inline-block;
        text-align: right;
        font-weight: 300;
        color: rgba(255, 255, 255, 0.75);
      }
      .item-value {
        margin-left: trl(16px);
        font-weight: 500;
        color: #ffb81c;
        line-height: trl(16px);
      }
    }
    .dz-icon {
      width: trl(16px);
      height: trl(16px);
      vertical-align: middle;
      display: inline-block;
      margin-right: trl(6px);
    }
  }
}
</style>
<style lang="scss" scoped>

.map-big-screen {
  position: absolute;
  right: 0;
  width: 65vw;
  height: 70vh;
  overflow: hidden;
  top: 15vh;
  &.screen {
    height: 75vh;
    width: 65vw;
    top: 23vh;
  }
  .map-shadow {
    width: 100%;
    z-index: 3;
    position: absolute;
    top: 0vh;
    left: 0;
    height: 15vh;
    background: url('../../../assets/images/big_screen_bg.png') repeat;
    background-size: contain;
    background-position: top left;
    &.down {
      height: 15vh;
      bottom: 0;
      transform: rotate(180deg);
      top: inherit;
    }
  }

  .map-big-screen-over {
    width: 100%;
    position: relative;
    height: 100%;
  }
  .goBack {
    position: absolute;
    color: #fff;
    right: 1vw;
    cursor: pointer;
    z-index: 6;
  }
  .map-container {
    position: absolute;
    width: 100%;
    z-index: 2;
    top: 0;
    height: 100%;
  }
  ::v-deep {
    .el-loading-mask {
      background-color: rgba(255, 255, 255, 0.01);
    }
  }
}
</style>
